import * as Actions from './location.actions';
import {AusmitError} from "../../shared/interfaces";

/*Defining the state shape*/
export interface State {
	error: AusmitError | null;
	hasError: boolean;
	requestProcessing: boolean;
	LocationByLatLong: {
		requestProcessing: boolean;
		criteria: any;
		response: any;
	},
	GetShopCountByLocation: {
		requestProcessing: boolean;
		criteria: any;
		response: any;
	},
	MarketplaceAnalytics: {
		requestProcessing: boolean;
		criteria: any;
		response: any;
	},
}

/*Setting the initial state*/
export const initialState: State = {
	error: null,
	hasError: false,
	requestProcessing: false,
	LocationByLatLong: {
		requestProcessing: false,
		criteria: null,
		response: null,
	},
	GetShopCountByLocation: {
		requestProcessing: false,
		criteria: null,
		response: null,
	},
	MarketplaceAnalytics: {
		requestProcessing: false,
		criteria: null,
		response: null,
	}
};

/*Creating the reducer function*/
export function LocationReducer(
	state = initialState,
	action: Actions.Actions
): State {
	switch (action.type) {
		case Actions.ActionTypes.LocationByLatLong: {
			return {
				...state,
				LocationByLatLong: {
					...state.LocationByLatLong,
					criteria: action.payload,
					requestProcessing: true,
				}
			};
		}
		case Actions.ActionTypes.LocationByLatLongSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				LocationByLatLong: {
					...state.LocationByLatLong,
					response: action.payload,
					requestProcessing: false,
				}
			};
		}
		case Actions.ActionTypes.LocationByLatLongError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				LocationByLatLong: {
					...state.LocationByLatLong,
					requestProcessing: false,
				}
			};
		}

		case Actions.ActionTypes.GetShopCountByLocation: {
			return {
				...state,
				GetShopCountByLocation: {
					...state.GetShopCountByLocation,
					criteria: action.payload,
					requestProcessing: true,
				}
			};
		}
		case Actions.ActionTypes.GetShopCountByLocationSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				GetShopCountByLocation: {
					...state.GetShopCountByLocation,
					requestProcessing: false,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.GetShopCountByLocationError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetShopCountByLocation: {
					...state.GetShopCountByLocation,
					requestProcessing: false,
				}
			};
		}

		case Actions.ActionTypes.MarketplaceAnalytics: {
			return {
				...state,
				MarketplaceAnalytics: {
					...state.MarketplaceAnalytics,
					criteria: action.payload,
					requestProcessing: true,
				}
			};
		}
		case Actions.ActionTypes.MarketplaceAnalyticsSuccess: {
			return {
				...state,
				error: null,
				hasError: false,
				MarketplaceAnalytics: {
					...state.MarketplaceAnalytics,
					requestProcessing: false,
					response: action.payload
				}
			};
		}
		case Actions.ActionTypes.MarketplaceAnalyticsError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				MarketplaceAnalytics: {
					...state.MarketplaceAnalytics,
					requestProcessing: false,
				}
			};
		}

		default:
			return state;
	}
}
